import React from 'react';

// UK mobile: 07704885084 -> international wa.me format (drop leading 0, prefix 44)
const WHATSAPP_NUMBER = '447704885084';
const DEFAULT_MESSAGE =
  "Hi Mouldsurv, I'd like to enquire about a mould or damp survey for my property.";

export const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Mouldsurv on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-24 right-4 sm:bottom-28 sm:right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-lg shadow-green-900/30 px-4 py-3 sm:px-5 sm:py-4 transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="currentColor"
        aria-hidden="true"
        className="w-6 h-6 sm:w-7 sm:h-7"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.065 0-.122-.029-.18-.064-.44-.198-.83-.538-1.139-.801-.28-.234-.516-.515-.744-.809-.205-.264-.498-.612-.498-.977 0-.348.333-.58.468-.82.148-.239.275-.459.275-.728 0-.282-.06-.462-.186-.732-.216-.465-.53-1.201-.72-1.614-.175-.375-.333-.435-.6-.435-.085 0-.166-.007-.258-.007a.536.536 0 0 0-.386.18c-.387.386-.72 1.017-.72 1.956 0 .94.333 1.884 1.022 2.83.685.947 2.47 2.826 5.145 4.098.803.383 1.447.61 1.944.784.81.259 1.55.221 2.135.134.65-.097 1.995-.815 2.274-1.599.274-.79.274-1.466.195-1.6-.074-.13-.28-.205-.595-.36-.314-.155-1.86-.916-2.15-1.022-.285-.105-.5-.155-.715.16zM16 4.8c-6.186 0-11.2 5.014-11.2 11.2 0 1.939.504 3.842 1.46 5.53L4.8 27.2l5.807-1.52A11.148 11.148 0 0 0 16 27.2c6.186 0 11.2-5.014 11.2-11.2S22.186 4.8 16 4.8zm0 20.544a9.35 9.35 0 0 1-4.778-1.3l-.343-.204-3.553.93.95-3.454-.224-.358a9.344 9.344 0 1 1 7.948 4.387z" />
      </svg>
      <span className="hidden sm:inline font-semibold whitespace-nowrap">Chat on WhatsApp</span>
    </a>
  );
};
